import { Stack, Typography } from "@mui/material";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import TypeTitle from "./TypeTitle";

// ----------------------------------------------------------------------

export default function EmptyApps() {
	const { translate } = useLocales();

	return (
		<>
			<Stack sx={{ ml: { xs: 1, sm: 1.5 } }}>
				<TypeTitle />
				<Typography color='text.primary' noWrap sx={{ mt: 1 }} variant='subtitle2'>
					{translate("nav_app_section.add_app")}
				</Typography>
			</Stack>
			<Iconify icon='material-symbols:add' ml='auto' width={20} />
		</>
	);
}
